<script lang="ts">
  import { FormGroup, Tag } from 'carbon-components-svelte';

  import type { AttributeOptions } from '../modules/attributes';

  type Props = {
    attributes: AttributeOptions;
  };
  const { attributes }: Props = $props();
</script>

<FormGroup legendText="Presets">
  <Tag
    data-testid="preset--event"
    interactive
    onclick={() => {
      attributes.manifest = '';
      attributes.encodedManifest = '';
      attributes.env = 'int';
      attributes.id = '64291f09-6d5e-4334-b088-ca593eafac16';
      attributes.type = 'event';
    }}>Momentum (Event)</Tag>
  <Tag
    data-testid="preset--library"
    interactive
    onclick={() => {
      attributes.manifest = '';
      attributes.encodedManifest = '';
      attributes.env = 'prod';
      attributes.id =
        'OTI3MTIwNjgtNDg0MC00ZWEwLWEzOWUtNjY1Y2ZhODg5ZGE3OjZiOWZkMWY2LWE0N2YtMTFlYi05NjczLWQ3YjFiYThhYWI4OA%3D%3D';
      attributes.type = 'library';
    }}>VOD Prod (Library)</Tag>
  <Tag
    data-testid="preset--playlist"
    interactive
    onclick={() => {
      attributes.manifest = '';
      attributes.encodedManifest = '';
      attributes.env = 'int';
      attributes.id =
        'NmRjZWJlNDYtNDFjMS00OWY5LWEzMTgtODA4MWQxNDM5NGUzOjlhYTdkMDUwLTA0NGYtMTFlZC05ZGVjLWE3ZDM1MTJjN2JiYg==';
      attributes.version = '';
      attributes.type = 'playlist';
    }}>VOD Int (Playlist)</Tag>
  <Tag
    data-testid="preset--offline"
    interactive
    onclick={() => {
      attributes.manifest = '';
      attributes.encodedManifest = '';
      attributes.id = '14291f27-5d5e-7334-c081-ba593eafac31';
      attributes.env = 'prod';
      attributes.type = '';
    }}>Offline</Tag>
  <Tag
    data-testid="preset--dash"
    interactive
    onclick={() => {
      attributes.manifest = `http${
        !import.meta.env.DEV ? 's' : ''
      }://storage.googleapis.com/shaka-demo-assets/angel-one/dash.mpd`;
      attributes.encodedManifest = '';
      attributes.id = '';
      attributes.type = '';
    }}>Dash Manifest</Tag>
  <Tag
    data-testid="preset--hls"
    interactive
    onclick={() => {
      attributes.manifest = `http${
        !import.meta.env.DEV ? 's' : ''
      }://storage.googleapis.com/shaka-demo-assets/bbb-dark-truths-hls/hls.m3u8`;
      attributes.encodedManifest = '';
      attributes.id = '';
      attributes.type = '';
    }}>HLS Manifest</Tag>
</FormGroup>
